import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import MobileHome from '@/views/MobileHome'
import Privacy from '@/views/Privacy'
import Service from '@/views/Service'
import NewsList from '@/views/components/NewsList'
import MobileNewsList from '@/views/components/MobileNewsList'
import NewsDetails from '@/views/components/NewsDetails'
import MobileNewsDetails from '@/views/components/MobileNewsDetails'
import Mkt from '@/views/components/Mkt'
import Mkc from '@/views/components/Mkc'
import Card from '@/views/components/Card'

Vue.use(Router)

export default new Router({
  mode: 'history', // hash模式注释掉
  // base: './',
  routes: [{
      path: '/NewsList',
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: MobileHome
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    },
    {
      path: "/NewsList",
      name: "NewsList",
      component: NewsList
    },
    {
      path: "/NewsDetails",
      name: "NewsDetails",
      component: NewsDetails
    },
    {
      path: "/MobileNewsList",
      name: "MobileNewsList",
      component: MobileNewsList
    },
    {
      path: "/MobileNewsDetails",
      name: "MobileNewsDetails",
      component: MobileNewsDetails
    },
    {
      path: "/Mkt",
      name: "Mkt",
      component: Mkt
    },
    {
      path: "/Mkc",
      name: "Mkc",
      component: Mkc
    },
    {
      path: "/Card",
      name: "Card",
      component: Card
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js